import * as React from 'react';
import {Breadcrumbs, Link, Typography} from '@mui/material';


export default function Execute(props) {
	const [breadcrumbs, setBreadcrumbs] = React.useState([]);

  function selectThisTopic(obj){
		props.selectTopic(obj);
  }

  React.useEffect(() => {
        ///alert(JSON.stringify(props.topicObj));
        if(props.topicObj && props.topicObj.topicId>0 && props.topicObj.pathIds && props.topicObj.pathIds.length>0){
            ///const pathIds = '31.54.228.1689.';
            createBreadCrumbs(props.topicObj.pathIds);
        }else{
            setBreadcrumbs([]);
        }
  }, [props.topicObj]);


    function getBCNode(breadCrumbArr, treeArr, pathArr, n){
        for(let i=0; i<treeArr.length; i++){
            if(treeArr[i].topicId===parseInt(pathArr[n])){
                if(pathArr && pathArr.length-1>n){
                    breadCrumbArr.push(
                        <Link 										
                            style={{fontSize: 12}}
                            underline="hover"
                            key={'x'+pathArr[n]}
                            color="inherit"
                            href={'javascript:;'}	
                            onClick={()=>{selectThisTopic(treeArr[i])}}									
                            >
                            {treeArr[i].topicName}
                        </Link>							
                    );
                }else{
                    breadCrumbArr.push(
                        <Typography
                        style={{fontSize: 12}} 
                        key={999} 
                        color="text.primary">
                            {treeArr[i].topicName}
                        </Typography>
                    );
                }
                n+=1;
                if(pathArr[n] && parseInt(pathArr[n])>0 && treeArr[i].children && treeArr[i].children.length){
                    getBCNode(breadCrumbArr, treeArr[i].children, pathArr, n);
                }
            }
        }

        setBreadcrumbs(breadCrumbArr);
    }


  function createBreadCrumbs(pathIds){
        let breadCrumbArr = [];
        breadCrumbArr.push(
            <Link								    									
                underline="hover"
                key={'home'}
                color="inherit"
                href={'javascript:;'}
                onClick={()=>{selectThisTopic({})}}										
                >
                <i className='fa fa-home' ></i>
            </Link>
        );
            
            if(pathIds){
                let pathIdArr = pathIds.substring(0,pathIds.length-1).split('.');
                let i=0; 
                    for(let j=0; j<props.topicTree.length; j++){
                        if(props.topicTree[j].topicId===parseInt(pathIdArr[0])){
                            if(pathIdArr && pathIdArr.length>1){
                                breadCrumbArr.push(
                                    <Link 										
                                        style={{fontSize: 12}}
                                        underline="hover"
                                        key={i+1}
                                        color="inherit"
                                        href={'javascript:;'}	
                                        onClick={()=>{selectThisTopic(props.topicTree[j])}}									
                                    >
                                        {props.topicTree[j].topicName}
                                    </Link>							
                                );
                            }else{
                                breadCrumbArr.push(
                                    <Typography
                                    style={{fontSize: 12}} 
                                    key={999} 
                                    color="text.primary">
                                        {props.topicTree[j].topicName}
                                    </Typography>
                                );
                            }
                            i+=1;
                            if(pathIdArr[i] && parseInt(pathIdArr[i])>0 && props.topicTree[j].children && props.topicTree[j].children.length){
                                getBCNode(breadCrumbArr, props.topicTree[j].children, pathIdArr, i);
                            }else{
                                setBreadcrumbs(breadCrumbArr);
                            }
                        }
                    }
            }


  }

  return (
    <>
    <Breadcrumbs maxItems={window.screen.width<481?2:100} separator="›" aria-label="breadcrumb">
		{breadcrumbs}
	</Breadcrumbs>
    </>
  );
}


